/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Shader from "App/render/webgl/shaders/shader";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import Factory from "App/render/webgl/shaders/factory";
import GLShader from "App/render/webgl/renderables/shader";
import GLFactory from "App/render/webgl/renderables/factory";

import * as vsDefines from "App/shaders/common/defines.vs";
import * as fsDefines from "App/shaders/common/defines.fs";
import * as fsDefaultPrecision from "App/shaders/common/default_precision.fs";
import * as fsApplyTextureToSurface from "App/shaders/common/apply_texture_to_surface.fs";
import * as vsOpaque from "App/shaders/bin/opaque.vs";
import * as fsOpaque from "App/shaders/bin/opaque.fs";
import IScene from "js_interface/src/scene_interface";

export default
class ChunkLODNodeOpaque extends Shader {

    public static TypeName: string = "ChunkLODNodeOpaque";

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph) {
        super(aSceneAPI, aRenderGraph);
    }

    public static create(aSceneAPI, aRenderGraph): ChunkLODNodeOpaque {
        return new ChunkLODNodeOpaque(aSceneAPI, aRenderGraph);
    }

    public initialize() {
        super.initialize();

        // the order matters!
        this._renderables = [<GLShader>GLFactory.create(GLShader, this._sceneAPI, this._renderGraph, null)];

        this._renderables[0].attachVertexShader(vsDefines);
        this._renderables[0].attachFragmentShader(fsDefaultPrecision);
        this._renderables[0].attachFragmentShader(fsDefines);

        this.initTransformation(this._renderables[0]);
        this.initLogarithmicDepthBuffer(this._renderables[0]);
        this.initLighting(this._renderables[0]);
        this.initClippingPlane(this._renderables[0]);
        this.initXRay(this._renderables[0]);

        this._renderables[0].attachFragmentShader(fsApplyTextureToSurface);

        this._renderables[0].addPreprocessorDefinition("#define CHUNK_LOD");
        this._renderables[0].addPreprocessorDefinition("#define TEXTURED");
        this._renderables[0].attachVertexShader(vsOpaque);
        this._renderables[0].attachFragmentShader(fsOpaque);

        this._renderables[0].compile();

        this._renderables[0].setRenderablesFilters(["material", "texture", "renderOptions"]);
    }
}

Factory.register(ChunkLODNodeOpaque);
